import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Nav.css';

const links = [
  { to: '/', label: 'Home', color: '#CC1100' },
  { to: '/projects', label: 'Projects', color: '#2E7A30' },
  { to: '/research', label: 'Research', color: '#1A4FCC' },
  { to: '/about', label: 'About', color: '#C89800' },
  { to: '/contact', label: 'Contact', color: '#2C2C28' },
];

function Nav() {
  const location = useLocation();

  return (
    <nav className="nav">
      <span className="nav-logo">NT_SONG</span>
      <div className="nav-links">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`nav-key ${location.pathname === link.to ? 'active' : ''}`}
          >
            <span className="dot" style={{ background: link.color }} />
            {link.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}

export default Nav;